import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { IntegrationT } from 'routes/IntegrationsList/types';
import { INTEGRATIONS_QUERY_KEY } from 'shared/api/constants/queryKeys';
import { RQAPICallWithData } from 'store/APIClient';

const ONE_HOUR_MS = 60 * 60 * 1000;

export const useAPIGetIntegrations = <T = IntegrationT[]>(
    // The select option can be used to transform the data returned by the endpoint
    options?: Pick<UseQueryOptions<IntegrationT[], unknown, T>, 'select'>,
) =>
    useQuery({
        queryKey: [INTEGRATIONS_QUERY_KEY],
        queryFn: async () => {
            const response = await RQAPICallWithData<IntegrationT[]>({
                endpoint: 'integrations',
                method: 'GET',
            });
            return response.content.data;
        },
        staleTime: ONE_HOUR_MS,
        select: options?.select,
    });
